import { Attribute as e } from "../Attribute.js";
import { AttributeDefinitions as a } from "../AttributeDefinitions.js";
import { Node as s } from "./Node.js";
class i extends s {
  static TYPE = "tab";
  /** @internal */
  static _fromJson(t, r, n = !0) {
    return new i(r, t, n);
  }
  /** @internal */
  static _attributeDefinitions = i._createAttributeDefinitions();
  /** @internal */
  static _createAttributeDefinitions() {
    const t = new a();
    return t.add("type", i.TYPE, !0).setType(e.STRING), t.add("id", void 0).setType(e.STRING), t.add("name", "[Unnamed Tab]").setType(e.STRING), t.add("altName", void 0).setType(e.STRING), t.add("helpText", void 0).setType(e.STRING), t.add("component", void 0).setType(e.STRING), t.add("config", void 0).setType("any"), t.add("floating", !1).setType(e.BOOLEAN), t.addInherited("enableClose", "tabEnableClose").setType(e.BOOLEAN), t.addInherited("closeType", "tabCloseType").setType("ICloseType"), t.addInherited("enableDrag", "tabEnableDrag").setType(e.BOOLEAN), t.addInherited("enableRename", "tabEnableRename").setType(e.BOOLEAN), t.addInherited("className", "tabClassName").setType(e.STRING), t.addInherited("icon", "tabIcon").setType(e.STRING), t.addInherited("enableRenderOnDemand", "tabEnableRenderOnDemand").setType(e.BOOLEAN), t.addInherited("overflow", "overflow").setType(e.STRING), t.addInherited("enableFloat", "tabEnableFloat").setType(e.BOOLEAN), t.addInherited("borderWidth", "tabBorderWidth").setType(e.NUMBER), t.addInherited("borderHeight", "tabBorderHeight").setType(e.NUMBER), t;
  }
  /** @internal */
  _tabRect;
  /** @internal */
  _renderedName;
  /** @internal */
  _extra;
  /** @internal */
  _window;
  /** @internal */
  constructor(t, r, n = !0) {
    super(t), this._extra = {}, i._attributeDefinitions.fromJson(r, this._attributes), n === !0 && t._addNode(this);
  }
  getWindow() {
    return this._window;
  }
  getTabRect() {
    return this._tabRect;
  }
  /** @internal */
  _setTabRect(t) {
    this._tabRect = t;
  }
  /** @internal */
  _setRenderedName(t) {
    this._renderedName = t;
  }
  /** @internal */
  _getNameForOverflowMenu() {
    const t = this._getAttr("altName");
    return t !== void 0 ? t : this._renderedName;
  }
  getName() {
    return this._getAttr("name");
  }
  getHelpText() {
    return this._getAttr("helpText");
  }
  getComponent() {
    return this._getAttr("component");
  }
  /**
   * Returns the config attribute that can be used to store node specific data that
   * WILL be saved to the json. The config attribute should be changed via the action Actions.updateNodeAttributes rather
   * than directly, for example:
   * state.model.doAction(
   *   FlexLayout.Actions.updateNodeAttributes(node.getId(), {config:myConfigObject}));
   */
  getConfig() {
    return this._attributes.config;
  }
  /**
   * Returns an object that can be used to store transient node specific data that will
   * NOT be saved in the json.
   */
  getExtraData() {
    return this._extra;
  }
  isFloating() {
    return this._getAttr("floating");
  }
  getIcon() {
    return this._getAttr("icon");
  }
  isEnableClose() {
    return this._getAttr("enableClose");
  }
  getCloseType() {
    return this._getAttr("closeType");
  }
  isEnableFloat() {
    return this._getAttr("enableFloat");
  }
  isEnableDrag() {
    return this._getAttr("enableDrag");
  }
  isEnableRename() {
    return this._getAttr("enableRename");
  }
  getClassName() {
    return this._getAttr("className");
  }
  isEnableRenderOnDemand() {
    return this._getAttr("enableRenderOnDemand");
  }
  /** @internal */
  _setName(t) {
    this._attributes.name = t, this._window && this._window.document && (this._window.document.title = t);
  }
  /** @internal */
  _setFloating(t) {
    this._attributes.floating = t;
  }
  /** @internal */
  _layout(t, r) {
    t.equals(this._rect) || this._fireEvent("resize", { rect: t }), this._rect = t;
  }
  /** @internal */
  _delete() {
    this._parent._remove(this), this._fireEvent("close", {});
  }
  toJson() {
    const t = {};
    return i._attributeDefinitions.toJson(t, this._attributes), t;
  }
  /** @internal */
  _updateAttrs(t) {
    i._attributeDefinitions.update(t, this._attributes);
  }
  /** @internal */
  _getAttributeDefinitions() {
    return i._attributeDefinitions;
  }
  /** @internal */
  _setWindow(t) {
    this._window = t;
  }
  /** @internal */
  _setBorderWidth(t) {
    this._attributes.borderWidth = t;
  }
  /** @internal */
  _setBorderHeight(t) {
    this._attributes.borderHeight = t;
  }
  /** @internal */
  static getAttributeDefinitions() {
    return i._attributeDefinitions;
  }
}
export {
  i as TabNode
};
//# sourceMappingURL=TabNode.js.map
